import styled from 'styled-components';

import { ReactComponent as CheckIconSvg } from '@components/web/src/assets/icons/training/icon-check.svg';
import { BackButton } from '@components/web/src/atoms/Buttons/BackButton/BackButton';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS, GRADIENTS } from '@components/web/src/styles';

export const ProductFeedbackDonePageContainer = styled(Flexbox)`
  position: relative;
  background: ${GRADIENTS.primaryGradient};
  flex: 1;
  align-items: center;
`;

export const StyledBackButton = styled(BackButton)`
  background-color: ${COLORS.base.white};
  box-sizing: border-box;
  padding: 16px;
`;

export const TitleText = styled(Text)`
  color: ${COLORS.gray[25]};
  -webkit-text-stroke-width: 6px;
  -webkit-text-stroke-color: #338e9a;
  paint-order: stroke fill;
  text-shadow:
    0px 12px 16px rgba(16, 24, 40, 0.1),
    0px 4px 6px rgba(16, 24, 40, 0.05);
`;

export const Header = styled(Flexbox)`
  color: ${COLORS.base.white};
  width: 100%;
  text-align: center;
`;

export const Divider = styled(Flexbox)`
  position: relative;
  width: 286px;
  border-top: 1px solid ${COLORS.base.white};
`;

export const CheckIcon = styled(CheckIconSvg)`
  position: absolute;
  width: 45px;
  height: 44.938px;
  flex-shrink: 0;
`;

export const ProductDetails = styled(Flexbox)`
  text-align: center;
  padding: 31.96px 12px 35px;
  margin-bottom: 5px;
  & h3,
  & p {
    margin: 0;
  }
`;

export const ActionButtonWrapper = styled(Flexbox)`
  position: sticky;
  bottom: 0;
  z-index: 1;
  width: 100%;
  padding: 8px 16px;
  background: ${COLORS.base.white};
  margin-top: auto;
  box-shadow: 0px -8px 18px 0px rgba(16, 24, 40, 0.15);
`;
